// extracted by mini-css-extract-plugin
export default {"warn":"OfferAvailableTill_warn__JhNc5","info":"OfferAvailableTill_info__8FcA7"};